<template lang="html">
  <div id="success-stories-page">

    <section class="container main-section">
      <div class="container">
        <div class="row">
          <div class="col-12 col-title">
            <h1 class="title-s1">CASOS DE ÉXITO</h1>
          </div>

          <div class="col-12 col-videos">
            <div class="box-video" v-for="(v, vInx) in videos">
              <iframe :src="v.videoUrl" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      videos: [
        { videoUrl: 'https://www.youtube.com/embed/sIkiKCTxAsw?si=6qB7sxrrqM6ecB4h' },
        { videoUrl: 'https://www.youtube.com/embed/jAogmjuLrio?si=5sR8X-_6wiCHVKJx' },
        { videoUrl: 'https://www.youtube.com/embed/n9Kwdi8GuDo?si=hMnYcRkL8Mb9dqys' },
        { videoUrl: 'https://www.youtube.com/embed/G4XiVwPQeTE?si=Z_i8WIsOYviT8MD7' },
        { videoUrl: 'https://www.youtube.com/embed/F7OKhEO1jvY?si=Kl_R_rmYG7mHTExF' },
      ],
    }
  }
}
</script>
